/**
 * Reusable avatar display. Falls back to colored initials when no
 * image URL is present. Used in Navbar, Profile summary card, etc.
 */
export default function Avatar({ user, size = 40, src, className = '' }) {
  const url = src ?? user?.avatar;
  const label = user?.name || user?.email || 'User';
  const initials = label
    .split(/[\s@._-]+/)
    .filter(Boolean)
    .map((s) => s[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  const dimensions = {
    width: size,
    height: size,
    fontSize: Math.max(11, Math.round(size * 0.38)),
  };

  if (url) {
    return (
      <img
        src={url}
        alt={label}
        style={dimensions}
        className={`rounded-full object-cover border border-white/20 dark:border-gray-800 ${className}`}
      />
    );
  }

  return (
    <span
      style={dimensions}
      className={`inline-flex items-center justify-center rounded-full bg-gradient-to-br from-brand-500 to-brand-700 font-semibold text-white shadow-sm ${className}`}
      aria-label={label}
    >
      {initials || 'U'}
    </span>
  );
}
